export const excludedPages = ['/agb', '/impressum'];
